<template>

  <div class="planning-wrapper scrollable">
  
    <div class="limit" >
        <div class="table-subtitle">
          <h3>{{$t('dash.optimalTimes.title')}}</h3>
        </div>
        <p class="subtitle">
          {{$t('dash.optimalTimes.subtitle')}} {{formatDate(optimalTimes.date.request_at)}} : 
          {{$t('dash.reporting.from')}} {{formatDate(optimalTimes.date.since_at, false)}} 
          {{$t('dash.reporting.to')}} {{formatDate(optimalTimes.date.until_at, false)}} 
        </p>

        <div class="limit-wrapper">
          
          <vs-radio 
          name="content"
          vs-value="impressions"
          v-model="filter"
          :class="{ 'active' : filter === 'impressions'}">
              <!-- <Tooltip :text="`Rate = (  [  ( Impressions / #Posts ) / ( Total Impressions / Total #Posts )  ] -1 ) x100`">
              <span>{{$t('dash.reporting.impression')}}</span>
                &nbsp;
              </Tooltip> -->
              {{$t('dash.reporting.impression')}}
          </vs-radio>
          
          <vs-radio 
            name="content" 
            vs-value="clics" 
            v-model="filter"
            v-if="network !== 'instagram'" 
            :class="{ 'active' : filter === 'clics'}">
              <!-- <Tooltip :text="`Rate = (  [  ( ${$t('dash.reporting.clic')} / #Posts ) / ( Total ${$t('dash.reporting.clic')} / Total #Posts )  ] -1 ) x100`">
                <span> {{$t('dash.reporting.clic')}}</span>
                  &nbsp;
              </Tooltip> -->
              {{$t('dash.reporting.clic')}}
          </vs-radio>

          <vs-radio 
            name="content" 
            vs-value="engagement" 
            v-model="filter"
            :class="{ 'active' : filter === 'engagement'}">
              <!-- <Tooltip :text="`Rate = (Reach Engagement / #Posts) / max( Reach Engagement / #Posts )`">
                <span> {{$t('dash.reporting.engagements')}}</span>
                  &nbsp;
              </Tooltip> -->
                {{$t('dash.reporting.engagemment')}}
          </vs-radio>

          <Tooltip class="tooltipRefresh" :text="$t('dash.reporting.period_thirty_days')">
            <vs-button class="refreshBtn btn-img" v-if="interaction"  @click="refreshData">                    
              <img src="../../assets/img/icon_refresh_reload.svg" alt="search">
            </vs-button>
            &nbsp;
          </Tooltip>
      
        </div>
    </div>
  
    <div class="table-content">
      <ul class="table-head">
        <li class="row">
          <ul>
            <li class="day-column column"></li>
            <li :class="{ 'displayed' : indexHour % 3 === 0}" class="column hour-column" v-for="(hour, indexHour) in hours" :key="indexHour">
              <p>{{ $t(`dash.hour.${hour}`) }}</p>
            </li>
          </ul>
        </li>
      </ul>
      <ul class="table-body scrollable">  
        <li class="row" v-for="(day, keyDay) in (optimalTimes.optimalTimeSlots)" :key="keyDay">
          <ul>
            <li class="day-column column">
              <p>{{ $t(`dash.week.${keyDay}`)}}</p>
            </li>
            
            <li class="column" :class="{ 'bordered' : indexHour % 3 === 0, 'unbordered' : indexHour % 3 === 2}" v-for="(hour, indexHour) in day" :key="indexHour" @click="setScheduleDate(keyDay, indexHour)">

              <!-- clics heatmap -->
              
              <div class="hour-wrapper"  v-show="filter === 'clics'" v-if="hour != null"
                :style="hourWrapperStyle(hour.rateClicks)">
                <div class="hour-checkbox">
                <Tooltip :text="getTooltipTextCli(hour)" style='white-space: pre-line;' v-if="hour.rateClicks != null">       
                    <span style="margin:10px"></span>
                    &nbsp; 
                </Tooltip>
                </div>
              </div>
              
              <template lang="html">
                <!-- impressions heatmap -->
                <div class="hour-wrapper"  v-show="filter === 'impressions'" v-if="hour != null"
                  :style="hourWrapperStyle(hour.rateImpressions)">
                  <div class="hour-checkbox">
                    <Tooltip :text="getTooltipTextImp(hour)" v-if="hour.rateImpressions != null">       
                      <span style="margin:10px"></span>
                      <p></p>
                      &nbsp;
                    </Tooltip> 
                  </div>
                </div>
              </template>
              <!-- ReachEngagement heatmap -->
              <div class="hour-wrapper"  v-show="filter === 'engagement'" v-if="hour != null"
                :style="{'background-color': `rgba(178, 5, 100, ${hour.rateReachEngagement})`}">
                <div class="hour-checkbox">
                  <Tooltip :text="getTooltipTextEng(hour)" v-if="hour.rateReachEngagement != null">       
                    <span style="margin:10px"></span>
                    <p></p>
                    &nbsp;
                  </Tooltip> 
                </div>
              </div>

              <div class="hour-wrapper" v-else :style="{'background-color': `rgba(192,192,192)`}">
                <div class="hour-checkbox">
                  <Tooltip :text="$t('dash.no-activity')">       
                    <span style="margin:10px"></span>
                    <p></p>
                    &nbsp;
                  </Tooltip> 
                </div>
              </div>
              
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>

import moment from 'moment'
import Table from './Table.vue'
import Tooltip from './tooltip/tooltipInit.vue'

export default {
  components: { Table, Tooltip },
  name: 'component-optimal-posts-planning',

  props: {
    optimalTimes: Object,
    interaction: Boolean,
    network : String
  },
  
  data() {
    return {
      hours : ["12am", "1am", "2am", "3am", "4am", "5am", "6am", "7am", "8am", "9am", "10am", "11am", 
              "12pm", "1pm", "2pm", "3pm", "4pm", "5pm", "6pm", "7pm", "8pm", "9pm", "10pm", "11pm"],
      checkedNames: [],
      filter : 'impressions',
      //optimalTimes: []
    }
 
  },

  mounted() {
    //init planning with week prop
    for(let day in this.optimalTimes.optimalTimeSlots){
      for(var hour=0; hour < 24; hour++){ 
        if(day in this.optimalTimes.optimalTimeSlots) this.checkedNames.push(day+hour)
      }
    }     
  },
  
  methods: {
     
    formatDate(date, hour=true) {
      if (this.$i18n.locale === 'en') {
        return hour ? moment(date).format('MM/DD/YY hh:mm A').toString() 
                    : moment.unix(date).format('MM/DD/YY').toString()
      } else {
        return hour ? moment(date).locale(this.$i18n.locale || navigator.language).format('DD/MM/YY HH:mm').toString() 
                    : moment.unix(date).locale(this.$i18n.locale || navigator.language).format('DD/MM/YY').toString()
      }
    },

    hourWrapperStyle(rate){ 
      rate=parseInt(rate)   
      
      //1st porposal, min always < 0
      let minImpRate = -(this.optimalTimes.minImpRate)
      let val = (rate + minImpRate)/ (minImpRate + this.optimalTimes.maxImpRate)
      return {'background-color': `rgba(178, 5, 100, ${val+0.1})`}
      

      //2nd porposal
      // if(rate >= 0){
      //   let val = (rate/this.optimalTimes.maxImpRate)
      //   return {'background-color': `rgba(178, 5, 100, ${0.1+val})`}
      // }else{
      //   let val = (rate/this.optimalTimes.minImpRate)
      //   return {'background-color': `rgba(140, 130, 188, ${0.1+val})`}
      // }
    }, 

    getTooltipTextImp(hour){
      return hour.rateImpressions > 0 ? `${hour.nbPost} ${hour.nbPost > 1 ? 'posts' : 'post'} ${'- '+this.$t('dash.reporting.impression')} : ${hour.totalImpressions} ${'- '+this.$t('dash.reporting.performance')} : +${hour.rateImpressions}%`
                                      : `${hour.nbPost} ${hour.nbPost > 1 ? 'posts' : 'post'} ${'- '+this.$t('dash.reporting.impression')} :  ${hour.totalImpressions} ${'- '+this.$t('dash.reporting.performance')} : ${hour.rateImpressions}%`

    },
    getTooltipTextCli(hour){
      return hour.rateClicks > 0  ? `${hour.nbPost} ${hour.nbPost > 1 ? 'posts' : 'post'} ${'- '+this.$t('dash.reporting.clic')} : ${hour.totalClicks} ${'- '+this.$t('dash.reporting.performance')} : +${hour.rateClicks}%` 
                                  : `${hour.nbPost} ${hour.nbPost > 1 ? 'posts' : 'post'} ${'- '+this.$t('dash.reporting.clic')} : ${hour.totalClicks} ${'- '+this.$t('dash.reporting.performance')} : ${hour.rateClicks}%`
    },
    getTooltipTextEng(hour){
      return `${hour.nbPost} ${hour.nbPost > 1 ? 'posts' : 'post'} - Reach engagement : +${hour.totalReachEngagement}%` // alwayse >0
    },

    refreshData(){
      console.log('send event refresh data')
      this.$emit('refreshData')
      // if(localStorage.optimalTimes )
      //   this.optimalTimes = JSON.parse(localStorage.optimalTimes)
    },

    setScheduleDate(day, hour){
      if(this.interaction){
        console.log('send event to postOverlay with', day, hour)
        this.$emit('setScheduleDate', day, hour)
      }
    }

  }
}    
</script>
